import 'index.scss'

if (!process?.env?.REACT_APP_DOMAIN) {
  require('envs/_current')
}
